import type { ReactNode } from 'react';
import { useSetPageBackLink } from '../../contexts/PageHeaderContext';

interface BackLinkProps {
  to: string;
  children: ReactNode;
}

/**
 * Declarative back link for detail pages. Renders nothing in place;
 * registers the link via `PageHeaderContext` so it's rendered into the
 * reserved slot above `<main>` (see `ConsoleLayout`). Keeping the link
 * outside `<main>` means the page title's Y position is not affected by
 * whether or not a page declares a back link.
 *
 * Usage:
 *   <BackLink to={routes.console.spacePlugins(spaceId)}>Plugins</BackLink>
 */
export default function BackLink({ to, children }: BackLinkProps) {
  useSetPageBackLink({ to, label: children });
  return null;
}
